import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

export enum INVITATIONB2BPARTNERSTEPSTYPE {
  invitationB2bInit = 'initial',
  invitationB2bAccepted = 'accepted',
  invitationB2bRejected = 'rejected',
  invitationB2bAlreadyAccepted = 'already_accepted',
  invitationB2bAlreadyRejected = 'already_rejected',
  invitationB2bWrongAccount = 'wrong_account',
  invitationB2bOnlyForOwners = 'only_for_owners',
  invitationB2bInvitationResent = 'invitation_resent',
}

export type TInvitationB2BPartnerSteps = typeof INVITATIONB2BPARTNERSTEPSTYPE[keyof typeof INVITATIONB2BPARTNERSTEPSTYPE];

@Injectable({
  providedIn: 'root'
})

export class InvitationB2bPartnerService {

  constructor(
    private http: HttpClient,
  ) { }

  acceptInvitation(): Promise<any> {
    return this.http
      .post<any>(`/invitation/b2b/partner/accept`, {})
      .toPromise();
  }

  rejectInvitation(): Promise<any> {
    return this.http
      .post<any>(`/invitation/b2b/partner/reject`, {})
      .toPromise();
  }

  resendInvitation(): Promise<any> {
    return this.http
      .post<any>(`/invitation/b2b/partner/resend`, {})
      .toPromise();
  }
}
